import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "animate.css";
import { Pagination } from "antd";
import { ApiService } from "../../services/apiService";

const Index = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [displayedBlogs, setDisplayedBlogs] = useState([]);
  const [totalBlogs, setTotalBlogs] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 5;
  const navigate = useNavigate();

  const fetchBlogPosts = async () => {
    try {
      const response = await ApiService.getAllBlogs();
      const blogs = response.data.data;
      setBlogPosts(blogs);
      setTotalBlogs(blogs.length);
      setDisplayedBlogs(blogs.slice(0, pageSize));
    } catch (error) {
      console.error("Failed to fetch blog posts", error);
    }
  };

  useEffect(() => {
    fetchBlogPosts();
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    setDisplayedBlogs(blogPosts.slice(startIndex, endIndex));
  };

  const handleReadMore = (formatted_heading) => {
    navigate(`/blog/${formatted_heading}`);
  };

  const renderBlogContent = (content, formatted_heading) => {
    const anchorStyle = {
      color: "blue",
      textDecoration: "underline",
    };

    const styledContent = content.replace(
      /<a /g,
      `<a style="${Object.keys(anchorStyle)
        .map((key) => `${key}: ${anchorStyle[key]};`)
        .join(" ")}" target="_blank"`
    );
    return (
      <div className="flex flex-col items-center">
        <p
          className="font-FiraSans"
          dangerouslySetInnerHTML={{
            __html: `${styledContent.slice(0, 500)}...`,
          }}
        />
        <button
          className="text-[#f49a39] border-[#f49a39] border p-1 rounded-xl cursor-pointer"
          onClick={() => handleReadMore(formatted_heading)}
        >
          Read More
        </button>
      </div>
    );
  };

  return (
    <div className="px-16 lg:px-4 md:px-3 sm:px-2 xs:px-1 pt-2 pb-6 font-FiraSans">
      <h1 className="font-bold text-center text-4xl lg:text-2xl md:text-2xl sm:text-xl xs:text-xl">
        Blog Articles
      </h1>
      {totalBlogs > 0 ? (
        <>
          {displayedBlogs.map((blogPost) => (
            <div key={blogPost.blog_id} className="mt-4">
              <h1 className="font-Montserrat text-lg font-semibold text-center">
                {blogPost.heading}
              </h1>
              {renderBlogContent(blogPost.content, blogPost.formatted_heading)}
            </div>
          ))}
          <div className="flex justify-center mt-4">
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={totalBlogs}
              onChange={handlePageChange}
            />
          </div>
        </>
      ) : (
        <div className="flex items-center py-10 justify-center">
          <p className="font-medium text-2xl mb-8 animate__animated animate__bounceInLeft animate__infinite animate__slower">
            There are no available blog posts at the moment...
          </p>
        </div>
      )}
    </div>
  );
};

export default Index;
